import { getLinkToParent } from '@fm-nx/navigation';
import Link from 'next/link';
import classNames from 'classnames';
import { Icon } from '@fm-nx/svg';
import { useMemo } from 'react';
import { usePathname } from 'next/navigation';

type BackLinkPagePropTypes = {
    mode?: 'light' | 'dark';
};

export function BackLinkPage(props: BackLinkPagePropTypes) {
    const { mode = 'light' } = props;
    const pathname = usePathname();

    const parentLink = useMemo(() => {
        if (!pathname) return null;
        return getLinkToParent({ pathname });
    }, [pathname]);

    const textColor = classNames({
        'text-gray-900': mode === 'light',
        'text-white': mode === 'dark',
    });

    if (!parentLink) return null;

    return (
        <Link className="flex items-center justify-start mt-10" href={parentLink.href}>
            <Icon name="arrow" direction="left" color={mode === 'light' ? 'black' : 'white'} size="2xl" />

            <span className={`${textColor} inline-block ml-4 h-sm border-b-out pb-2`}>{parentLink.label}</span>
        </Link>
    );
}

export default BackLinkPage;
